<template>
    <span>
        <b-modal
            id="api-err-modal"
            v-model="apiErrModalShow"
            centered
            scrollable
            hide-footer
            hide-header-close
            no-close-on-backdrop
            no-close-on-esc
            title="Error"
            :header-bg-variant="'warning'"
            :header-text-variant="'light'"
        >
            <span v-html="err_msg"></span>
            <b-button class="mt-3" block @click="hideModal">OK</b-button>
        </b-modal>
        <!-- This Modal is for when the curator clicks the Download button on VecDyn data-->
        <b-modal
            id="download-csv-modal"
            v-model="downloadCSVModal"
            centered
            scrollable
            hide-footer
            hide-header-close
            no-close-on-backdrop
            no-close-on-esc
            title="Data Use Policy"
            :header-bg-variant="'dark'"
            :header-text-variant="'light'">
            <span v-html="'It is important for data publishers and for the reputation of data users that data is cited correctly.  Citation information for each record can be found inside the downloaded file. We would be grateful for you to also <a href=https://www.vectorbyte.org/blog/how-to-cite-us target=_blank rel=noopener noreferrer style=text-decoration:underline;>cite the VectorByte resource</a>. Data should be presumed to be licensed under <a href=https://creativecommons.org/licenses/by-nc/4.0/ target=_blank rel=noopener noreferrer style=text-decoration:underline;>CC-BY-NC</a>, but data generators may have used a more permissive license. Please check with the original data generator when in doubt.'"></span>
            <br>
            <b-button class="mt-3" style="margin-right:20px; margin-left:100px;" @click="hideModal">Cancel</b-button>
            <b-button class="mt-3" variant='primary' @click="downloadCSV">Agree and Download</b-button>
        </b-modal> 
        <!-- This modal pops up when the Download button is clicked -->
        <b-modal
            id="warning-modal"
            v-model="downloadProgressModal"
            centered
            scrollable
            hide-footer
            hide-header-close
            no-close-on-backdrop
            no-close-on-esc
            title="Download in Progress"
            :header-bg-variant="'warning'"
            :header-text-variant="'light'">
            <span v-html="'Please wait while the datasets get downloaded. This may take a minute or two.'"></span>
        </b-modal>
        <div class="container-fluid flex-wrapper">
            <ExplorerTitleArea :title="title" :mobile="userOnMobile" :img="logo" />
            <div class="flex-row height-by-content">
                <b-row>
                    <b-col cols="9" class="mr-1 mt-1">
                        <b-form-input
                            v-model="keywords"
                            placeholder="Search by phrase..."
                            @keypress.enter="searchByKeyword()"
                        ></b-form-input>
                    </b-col>
                    <b-col cols="3" class="mr-1 mt-1"></b-col>
                </b-row>
                <b-row v-for="index in queryFieldsetCount" :key="index">
                    <b-input-group >
                        <b-col cols="3" class="mt-1">
                            <b-form-select v-model="fieldArray[index-1]" :options="fieldDropdownOptions">
                            </b-form-select>
                        </b-col>
                        <b-col cols="3" class="mt-1">
                            <!-- <b-form-select v-model="operatorArray[index]" :options="operators" ></b-form-select> -->
                            <b-form-select v-model="operatorArray[index-1]">
                                <option
                                    v-for="(operator, idx) in operatorOptionsArray[index-1]"
                                    :key="idx"
                                    :value="operator.value"
                                    :title="operator.title || null"
                                >
                                    {{ operator.text }}
                                </option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="3" class="mt-1">
                            <b-form-input
                                v-model="termArray[index-1]"
                                placeholder="Enter a search term..."
                                @keypress.enter="searchByKeyword()"
                            ></b-form-input>
                        </b-col>
                        <b-col class="mt-1">
                            <b-button
                                v-if="queryFieldsetCount > 1"
                                class="mr-1"
                                size="sm"
                                @click="removeQueryFieldset(index-1)"
                            >-</b-button>
                            <b-button
                                v-else
                                class="mr-1"
                                disabled
                                size="sm"
                            >-</b-button>
                            <b-button
                                v-if="index === queryFieldsetCount"
                                class="mr-1"
                                size="sm"
                                @click="incrementQueryFieldset"
                            >+</b-button>
                        </b-col>
                    </b-input-group>
                </b-row>
                <!-- THIS IS NOT SOMETHING I'M SUPER PROUD OF. -->
                <!-- I was in a hurry to format this bit slightly differently whether the user was on a mobile 
                browser or not so it conditionally renders one version or the other depending... -->
                <!-- Mobile version -->
                <b-row v-if="userOnMobile">
                    <b-col cols="12" class="mt-0">
                        <div style="float: right; display: inline;">
                            <!-- <span v-if="options.totalRows <= selectedRecordsLimit">
                                <b-button class="ml-1" size="sm" @click="clearAllRows" v-if="allRowsSelected">
                                    Clear All Rows
                                </b-button>
                                <b-button class="ml-1" size="sm" @click="selectAllRows" v-else>
                                    Select All Rows
                                </b-button>
                            </span>
                            <span v-else>
                                <b-button class="ml-1" size="sm" disabled>
                                    Select All Rows
                                </b-button>
                            </span> -->
                            <b-button class="ml-1" style="width: 90px;" size="sm" @click="searchByKeyword">
                                Search
                            </b-button>
                            <b-button class="ml-1" style="width: 90px;" size="sm" @click="clear">
                                Clear
                            </b-button>
                            <b-button class="ml-4" style="width: 90px;" variant="primary" size="sm" @click="downloadCSVModal = true">
                                Download
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mt-4 mb-1" v-if="userOnMobile">
                    <b-col cols="12" >
                        <div v-if="options.totalRows > -1" style="position: absolute; right: 0; bottom: -5px;">
                            {{ options.totalRows }} records returned
                        </div>
                    </b-col>
                </b-row>
                <!-- Desktop version -->
                <b-row class="mb-2 mt-3" v-else>
                    <b-col cols="5">
                        <p class="mb-0">Click any row in the table to view its details page or click the checkbox beside any
                            number of rows and then click the download button to download their data.
                        </p>
                    </b-col>
                    <b-col cols="4" class="mt-1">
                        <div style="float: right; display: inline">
                            <!-- <span v-if="options.totalRows <= selectedRecordsLimit">
                                <b-button class="ml-1" size="sm" @click="clearAllRows" v-if="allRowsSelected">
                                    Clear All Rows
                                </b-button>
                                <b-button class="ml-1" size="sm" @click="selectAllRows" v-else>
                                    Select All Rows
                                </b-button>
                            </span>
                            <span v-else>
                                <b-button class="ml-1" size="sm" disabled title="Query must return 3000 rows or less.">
                                    Select All Rows
                                </b-button>
                            </span> -->
                            <b-button class="ml-1" style="width: 90px;" size="sm" @click="searchByKeyword">
                                Search
                            </b-button>
                            <b-button class="ml-1" style="width: 90px;" size="sm" @click="clear">
                                Clear
                            </b-button>
                            <b-button class="ml-4" style="width: 90px;" variant="primary" size="sm" @click="downloadCSVModal = true">
                                Download
                            </b-button>
                        </div>
                    </b-col>
                    <b-col cols="3">
                        <div style="position: relative; height: 100%; width: 100%;" v-if="!userOnMobile">
                            <!-- <span v-if="admin_authorized">
                                <b-button class="mt-1 ml-0" style="width: 120px;" variant="danger" size="sm" @click="downloadAllAsCSV">
                                Download ALL
                                </b-button>
                            </span> -->
                            <div v-if="options.totalRows > -1" style="position: absolute; right: 0; bottom: -5px;">
                                {{ options.totalRows }} records returned
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div id="content-div" class="flex-row content" style="">
                <b-table
                    ref="table"
                    striped 
                    hover 
                    responsive
                    selectable
                    select-mode='single'
                    bordered
                    head-variant="light"
                    :sticky-header="btableMaxHeight"
                    style="overflow-x:auto"
                    no-border-collapse
                    
                    @row-selected="onRowSelected"
                    :items="myProvider"
                    :fields="fields"
                    :busy.sync="loading"
                    :current-page="options.currentPage"
                    :per-page="options.perPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"

                    tbody-tr-class="vt-table-rows"
                >
                    <!-- A custom formatted header cell to allow for the displaying of tooltips -->
                    <template v-slot:head()="field">
                        <span :title="field.field.title" style="font-size: small; white-space: nowrap;">
                            {{ field.label }}
                        </span>
                    </template>
                    <!-- A custom formatted header cell to center the '✓' column header -->
                    <!-- <template v-slot:head(✓)="field">
                        <span 
                            :title="'Select one or more rows and then click Download to download the selected datasets.'"
                            style="font-size: small; white-space: nowrap;"
                        >
                            <center>
                                {{ field.label }}
                            </center>
                        </span>
                    </template> -->
                    <template v-slot:head(✓)>
                        <!-- Add tooltip and CSS styling. -->
                        <span
                        :title="'Select one or more rows and then click Download to download the selected datasets.'"
                        style="font-size: small; white-space: nowrap"
                        >
                            <b-form-select
                                v-model="selectionMode"
                            >
                                <option
                                :value="''"
                                title="Select an item."
                                disabled
                                >Select</option>
                                <!-- <option
                                :value="'all'"
                                title="Select ALL rows. This item is only available if the query returns 3000 rows or less."
                                disabled
                                v-if="options.totalRows > selectedRecordsLimit"
                                >All</option>
                                <option
                                :value="'all'"
                                title="Select ALL rows. This item is only available if the query returns 3000 rows or less."
                                v-else
                                >All</option> -->
                                <option
                                :value="'page'"
                                title="Select all rows on the current page."
                                >All on page</option>
                                <option
                                :value="'none'"
                                title="Clear all selected rows."
                                >None</option>
                            </b-form-select>
                        </span>
                    </template>
                    <!-- Special rendering for the "Taxons" column -->
                    <template v-slot:cell(SpeciesName)="data">
                        <span v-for="(item, index) in data.value" :key="index">
                            {{ item }}<span v-if="index != data.value.length - 1">, </span>
                        </span>
                    </template>
                    <!-- Special rendering for the "Years" column -->
                    <template v-slot:cell(Years)="data">
                        <span v-for="index in data.value" :key="index">
                            {{ index }} <br>
                        </span>
                    </template>
                    <!-- Special rendering for the "Tags" column -->
                    <template v-slot:cell(Tags)="data">
                        <span v-for="index in data.value" :key="index">
                            {{ index }} <br>
                        </span>
                    </template>
                    <!-- Special rendering for the "Collection Methods" column -->
                    <template v-slot:cell(CollectionMethods)="data">
                        <span v-for="index in data.value" :key="index">
                            {{ index }} <br>
                        </span>
                    </template>
                    <!-- Special rendering for the "UploadFile" column -->
                    <template v-slot:cell(UploadFile)="data">
                        <template v-if="data.value">
                            <a href="#" @click.prevent="navigateToFileDetail(data.value)">
                                {{ data.value }}
                            </a>
                        </template>
                        <template v-else>
                            {{ data.value }}
                        </template>
                    </template>
                    <!-- https://bootstrap-vue.org/docs/components/table#table-busy-state -->
                    <template #table-busy>
                        <div class="text-danger my-2">
                            <b-spinner class="align-left"></b-spinner>
                            <strong>&nbsp;Loading...</strong>
                        </div>
                    </template>
                    <!-- check boxes -->
                    <template v-slot:cell(✓)="data">
                        <center>
                        <b-form-checkbox
                            v-model="selectedRows"
                            :value="data.item[rowIdentifier]"
                            checked=true
                        ></b-form-checkbox>
                        </center>
                    </template>
                    <!-- add tooltips for each cell -->
                    <!-- <template v-slot:cell()="data">
                        <span :title='data.value'>{{ data.value}}</span>
                    </template> -->
                </b-table>
            </div>
            <div class="flex-row height-by-content">
                <b-pagination
                    v-if="options.totalRows"
                    v-model="options.currentPage"
                    :total-rows="options.totalRows"
                    :per-page="options.perPage"
                    align="right"
                    size="sm"
                    class="my-0 mb-2"
                ></b-pagination>
            </div>
        </div>
    </span>
</template>
<script>
import { mapActions, mapState } from "vuex";
import * as _ from "lodash";
import ExplorerTitleArea from "@/components/frontend/ExplorerTitleArea.vue";
import HandleErrors from "@/utilities/handle-errors";
import { HTTP } from "@/utilities/http-common";
import { getOperatorOptions, getArrayDiffIndex, extractArrayFromQuery } from "@/utilities/search-form-helpers";

export default {
    name: "explorer-search-form-and-table",
    mixins: [],
    components: {ExplorerTitleArea},
    props: {
        userOnMobile: Boolean,
        selectedRecordsLimit: Number,
        title: String,
        logo: String,
        endpoint: String,
        rowIdentifier: String,
    },
    data(){
        return{
            data: [],
            fields: [],
            fieldDefs: [],
            options: {
                currentPage: 1,
                totalRows: 0,
                perPage: 50
            },
            loading: false,
            selectedTSDRecordsLimit: 1700000,
            selectedRows: [], // holds the rows that have been 'checked' by the user.
            queryFieldsetCount: 1, // the number of sets of query fields
            fieldArray: [], // array of column arguments from the 'Select a column' fields
            operatorArray: [], // array of operator arguments from the 'Select an operator' fields
            termArray: [], // array of search arguments from the 'Enter a search term...' fields
            operatorOptionsArray: [], // store a set of options for the operator drop-down
            keywords: '', // space delimited list of search terms from the 'Search by phrase...' field
            sortDesc: false, // sort decending?
            fieldDropdownOptions: [], // this is now being built dynamically with buildOptions()
            sortBy: "Id", // by default, sort by 'ID'
            totalItems: 0, // initialize totalItems to 0 until query results come back
            err_msg: '',
            route_err: '',
            apiErrModalShow: false,
            downloadCSVModal: false,
            downloadProgressModal: false,
            allRowIDs: [],
            allRowsSelected: false,
            btableMaxHeight: "600px",
            rowIDString: "piids=",
            selectionMode: '',
            // About the rowIDString: when downloading a VECDYN (not VecTraits) csv, the endpoint needs to know what 
            // to query against. The VecDyn explorer will eventually need to be able to toggle between two types of 
            // tables. Each one will be based on a different object. On the old version of the VecDyn Explorer, we 
            // switched this variable between "piids=" and "smdids=" depending on which table was being displayed.
            // The old VecDyn Explorer page still exists as an example at http://localhost:8080/explore-vecdyn.
            // When this is no longer needed as an example, that page and route should be removed.
        };
    },
    watch: {
        view: function() {
            this.$refs.table.refresh();
        },
        'options.currentPage' () {
            this.addUrlQueryParams();
        },
        sortBy: function () {
            this.addUrlQueryParams();
        },
        sortDesc: function () {
            this.addUrlQueryParams();
        },
        allRowIDs: function() {
            this.checkSelectedRows();
        },
        compFieldArray: {
            // This is needed to change the options in the Operator drop down beside each field selector. 
            handler (newValue, oldValue)  {
                let fieldIndex = getArrayDiffIndex(newValue, oldValue);
                this.operatorOptionsArray[fieldIndex] = getOperatorOptions(this.fieldArray[fieldIndex]);
            },
            deep: true
        },
        $route() {
            // this watcher is used to update the table when query params change. This also triggers when the back and
            // forward buttons are clicked in the browser.
            this.unpackUrlQueryParams(this.$route.query);
            this.$refs.table.refresh();
        },
        selectionMode: {
            handler() {
                if (this.selectionMode == 'all') {
                    this.selectAllRows();
                } else if (this.selectionMode == 'page') {
                    this.selectPageRows();
                } else {
                    this.clearAllRows();
                }
            }
        },
        selectedRows: {
        // Store the selected rows in the store so that we can get them back if the user navigates away and comes back.
            handler() {
                this.setVDXCheckBoxes(this.selectedRows);
                // console.log(this.vdx_checkboxes);
            }
        }
    },
    computed: {
        compFieldArray () {
            // Wrapping fieldArray in a computed property because, when watching an array, you can't see the old value
            // of the array. The oldVal will show the same values as the newVal version of the array. Making this a
            // computed property will allow the watcher to see both values.
            // https://forum.vuejs.org/t/get-the-array-item-that-had-a-changed-value/31110/3
            let copiedArray = this.fieldArray.slice(0)

            return copiedArray;
        },
        ...mapState('vdxcheckboxes', ['vdx_checkboxes']),
        ...mapState("user", ["user", "myGroups"]),
        admin_authorized : function() {
            const that = this;
            let groups = ['admin', 'uploader', 'collaborator'];
            return Boolean((_.intersection(that.myGroups, groups)).length);
        },
    },
    methods: {
        ...mapActions("vdxcheckboxes", [
            "clearVDXCheckBoxes",
            "setVDXCheckBoxes"
        ]),
        navigateToFileDetail(value) {
            if (value) {
                const id = value.split(':')[0].trim();
                this.$router.push({ path: '/vd-fileupload-detail/' + id });
            }
        },
        hideModal() {
            this.apiErrModalShow = false;
            this.downloadCSVModal = false;
        },
        showDownloadProgressModal(){
            this.downloadCSVModal = false;
            this.downloadProgressModal = true;
        },
        myProvider(ctx) {
            this.$bvModal.hide('modal-1');
            const that = this;

            // build the params object to be sent with the request.
            var params = new URLSearchParams();
            params.append("page", ctx.currentPage);
            params.append("keywords", that.keywords);
            params.append("sort_column", that.sortBy);
            params.append("sort_dir", that.sortDesc ? "desc" : "asc");
            // params.append("return_as", that.returnAs)

            // load fieldArray, operatorArray, and termArray into the params obj
            var i;
            for (i=0; i < that.fieldArray.length; i++) {
                if (that.fieldArray[i].length != 0) {
                    params.append("field", that.fieldArray[i]);
                }
            }
            var j;
            for (j=0; j < that.operatorArray.length; j++) {
                if (that.operatorArray[j].length != 0) {
                    params.append("operator", that.operatorArray[j]);
                }
            }
            var k;
            for (k=0; k < that.termArray.length; k++) {
                if (that.termArray[k].length != 0) {
                    params.append("term", that.termArray[k]);
                }
            }

            var request = {
                params: params
            };

            return HTTP.get(this.endpoint, request)
            .then(response => {
                if (response.data.data == undefined){
                    that.loading = false;
                    this.err_msg = "No records found. ";
                    this.apiErrModalShow = true;
                    return [];

                } else {
                    // that.data = response.data.data.results;
                    let rawData = response.data.data.results;
                    that.data = Array.isArray(rawData) ? rawData : Object.values(rawData);
                    that.options.totalRows = parseInt(response.data.data.count);
                    that.allRowIDs = response.data.ids;
                    this.csvEndpoint = response.request.responseURL;
                    return that.data;
                }
            })
            .catch(error => {
                this.err_msg = HandleErrors.HandleErrors(error);
                this.apiErrModalShow = true;
                return [];
            });
        },
        downloadCSV(){
            // NOTE: that this download function will only work for VecDyn. If this component is going to work for 
            // both VecDyn AND VecTraits, the download function will need to be generalized.
            if (!this.selectedRows.length) {
                alert('You have not selected any rows! Please select the desired rows to proceed to download.');
                return;
            }

            let tsdRecordCount = 0;
            let vecdynParams = {
                vecdyn_datasets_list: this.selectedRows
            }

            HTTP.get(`/api/get-timeseries-data-record-count/`, {
                params: vecdynParams
            })
            .then((response) => {
                tsdRecordCount = response.data
                if (tsdRecordCount > this.selectedTSDRecordsLimit) {
                    alert("The selected records have exceeded the downloadable limit. Please deselect some datasets to allow download.")
                    return;
                }else{
                    this.showDownloadProgressModal();
                    this.downloadCSVModal = false;
                    let csvEndpoint = "/api/vecdyncsv/?return_as=csv&";

                    if(this.selectedRows.length){
                        var i;
                        for(i=0; i < this.selectedRows.length; i++){
                            csvEndpoint += (this.rowIDString + this.selectedRows[i]);
                            if (i != this.selectedRows.length - 1)
                                csvEndpoint += "&";
                        }
                    }

                    HTTP.get(csvEndpoint)
                    .then((response) => {
                        var fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        var fileLink = document.createElement("a");
                        fileLink.href = fileURL;
                        const now = new Date();
                        var fileName = "vec_dyn_download_" + now + ".csv";
                        fileLink.setAttribute("download", fileName);
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        this.downloadProgressModal = false;
                        this.$notify({
                            text: "Download successful!",
                            duration: 10000,
                            type: "success",
                        });
                    })
                    .catch((error) => {
                        this.downloadProgressModal = false;
                        this.err_msg = HandleErrors.HandleErrors(error);
                        this.apiErrModalShow = true;
                    });
                }
            }).catch((error) => {
                this.downloadProgressModal = false;
                this.err_msg = HandleErrors.HandleErrors(error);
                this.apiErrModalShow = true;
                this.workingModalShow = false;
            });
        },
        getFieldDefs() {
            const that = this;

            return HTTP.get(`/api/column-definitions/`).then((response) => {
                that.fieldDefs = response.data;
            })
            .catch((error) => {
                this.err_msg = HandleErrors.HandleErrors(error);
                this.apiErrModalShow = true;
            });
        },
        onRowSelected(items) {
            if (this.title == "VecTraits Explorer") {
                this.$router.push({name: 'vectraits-detail', params: {id: items[0]['OriginalID'] }});
            } else if (this.title == "VecDyn Explorer") {
                this.$router.push({name: 'vecdyn-detail', params: {id: items[0]['Id'] }});
            }
            
        },
        selectAllRows(){
            this.allRowsSelected = true;
            this.selectedRows = this.allRowIDs;
        },
        selectPageRows() {
            // this.allRowsSelected = false;
            this.selectedRows = [];
            // const collection = document.getElementsByName("chk");  // Because we're using bootstrap-vue, this won't work
            const collection = document.getElementsByClassName("custom-control-input");  // get all <b-form-checkbox> objs
            for (let i = 0; i < collection.length; i++) {  // Loop through all the b-f-checkboxes
                if (collection[i].type == "checkbox") {  // Make sure we're only dealing with the checkbox itself
                    collection[i].checked = true;  // set to true to "check" it.
                    this.selectedRows.push(collection[i].value);  // Add the row's value to the selectedRows array.
                }
            }
        },
        clearAllRows(){
            this.selectedRows = [];
            this.allRowsSelected = false;
        },
        beforeRouteLeave(to, from, next) {
            this.$bvModal.hide('modal-1');
            next();
        },
        incrementQueryFieldset() {
            this.queryFieldsetCount += 1;
        },
        decrementQueryFieldset() {
            this.queryFieldsetCount -= 1;
            this.fieldArray.pop();
            this.operatorArray.pop();
            this.operatorOptionsArray.pop();
            this.termArray.pop();
        },
        removeQueryFieldset(index) {
            this.queryFieldsetCount -= 1;
            this.fieldArray.splice(index, 1);
            this.operatorArray.splice(index, 1);
            this.operatorOptionsArray.splice(index, 1);
            this.termArray.splice(index, 1);
        },
        // When the Search button is clicked, reset defaults and get results
        searchByKeyword(){
            // We always want to start on the first page of results
            this.options.currentPage = 1;
            this.$refs.table.refresh();
            this.selectedRows = [];
            this.addUrlQueryParams();
        },
        buildFieldsArray(defs) {
            let def_dict = {};
            defs.forEach(function (obj) {
                def_dict[obj.field_name] = obj.definition;
            });

            let fields = [
                {key:"✓", sortable:false, tdClass:"vt-table-cell-mid center-checkbox"},
                {key:"SpeciesName", sortable:true, tdClass:"vt-table-cell-wide",},
                {key:"Title", sortable:true, tdClass:"vt-table-cell-wide",},
                {key:"ContactName", sortable:true, tdClass:"vt-table-cell",},
                {key:"Tags", sortable:true, tdClass:"vt-table-cell",},
                {key:"Collections", sortable:true, tdClass:"vt-table-cell",},
                {key:"Years", sortable:true, tdClass:"vt-table-cell",},
                {key:"CollectionMethods", sortable:true, tdClass:"vt-table-cell",},
            ];
            if (this.admin_authorized == true) {
                fields.push({key:"EmbargoReleaseDate", sortable:true, tdClass:"vt-table-cell",},);
                // fields.push({key:"UploadFile", sortable:false, tdClass:"vt-table-cell",},);
            }
            return fields
        },
        // Populate the columns drop-down using the keys from the fields array
        buildFieldDropdownOptions(){
            this.fieldDropdownOptions = [];

            // Add a default value to display a placeholder help text.
            this.fieldDropdownOptions.push({ value: '', text: 'Select a column', disabled: true },);

            this.fields.forEach(field => {
                this.fieldDropdownOptions.push({value: field.key, text: field.key});
            })
            //remove EmbargoReleaseDate from the fieldDropdownOptions array
            this.fieldDropdownOptions.splice(this.fieldDropdownOptions.indexOf("EmbargoReleaseDate"), 1);
            //add ContactName to the fieldDropdownOptions array

            // remove the "Select" field from the fieldDropdownOptions array
            this.fieldDropdownOptions.splice(1, 1);
        },
        clear(){
            this.options.currentPage = 1;
            this.queryFieldsetCount = 1;
            this.fieldArray = [];
            this.operatorArray = [];
            this.termArray = [];
            this.keywords = '';
            this.sortBy = "Id";
            this.sortDesc = false;
            this.selectedRows = [];
            this.$refs.table.refresh();

            // set the default values for the select column and select operator fields to display default text
            this.fieldArray[0] = '';
            this.operatorArray[0] = '';
            this.clearUrlQueryParams();
        },
        unpackUrlQueryParams(query_obj){
            // if there are query params in the URL fetch them and load them into local vars. For example:
            // http://localhost:8080/vectraits-datasets?keywords=aedes&field=OriginalID&field=OriginalTraitName&operator=sw&operator=contains&term=MSS&term=wing
            this.keywords = '';
            if ("keywords" in query_obj) {
                this.keywords = query_obj.keywords;
            }

            this.fieldArray = undefined;
            this.operatorArray = undefined;
            this.termArray = undefined;

            this.fieldArray = extractArrayFromQuery(query_obj, "field");
            this.operatorArray = extractArrayFromQuery(query_obj, "operator");
            this.termArray = extractArrayFromQuery(query_obj, "term");

            this.queryFieldsetCount = this.fieldArray.length;

            this.sortBy = "Id";
            if ("sort_by" in query_obj){
                this.sortBy = query_obj.sort_by;
            }
            this.sortDesc = false;
            if ("sort_desc" in query_obj){
                this.sortDesc = true;
            }
            this.options.currentPage = 1;
            if ("page" in query_obj) {
                this.options["currentPage"] = query_obj.page;
            }
        },
        addUrlQueryParams(){
            // when called, add the values of local vars into the URL as query params.
            let query = { };

            if (this.keywords) {
                query['keywords'] = this.keywords;
            }
            if (this.fieldArray[0]) {
                query['field'] = this.fieldArray;
            }
            if (this.operatorArray[0]) {
                query['operator'] = this.operatorArray;
            }
            if (this.termArray[0]) {
                query['term'] = this.termArray;
            }
            if (this.sortBy != "Id" && this.sortBy != "") {
                query["sort_by"] = this.sortBy;
            }
            if (this.sortDesc) {
                query["sort_desc"] = true;
            }

            // https://github.com/vuejs/vue-router/issues/3013
            // https://github.com/vuejs/vue-router/issues/2872
            query['__key'] = Date.now();

            // console.log("    Query obj: ", query);

            if (this.options.currentPage != 1) {
                query['page'] = this.options.currentPage;
            }

            this.$router.push({ query }).catch(err => {this.route_err = err});
        },
        clearUrlQueryParams(){
            this.$router.push({ query: { }}).catch(err => {this.route_err = err});

        },
        resizeTableDiv() {
            let divElement = document.querySelector("#content-div");
            let elemHeight = divElement.clientHeight;
            this.btableMaxHeight = (elemHeight - 70).toString() + 'px'
        },
        checkSelectedRows(){
            if (this.options.totalRows > this.selectedRecordsLimit) {
                this.allRowsSelected = false;
            } else {
                if (this.allRowsSelected) {
                    this.selectedRows = this.allRowIDs;
                }
            }
        },
        doiString: function (doi) {
            if (doi == null) {
                return null;
            }

            if (doi.startsWith('http://')){
                return doi.replace('http://', '');
            } else if (doi.startsWith('https://')){
                return doi.replace('https://', '');
            }

            return doi;
        },
    },
    created(){
        // set the default values for the select column and select operator fields to display default text
        this.fieldArray[0] = "";
        this.operatorArray[0] = "";
        this.unpackUrlQueryParams(this.$route.query);
        window.addEventListener("resize", this.resizeTableDiv);
        this.fieldDefs = this.getFieldDefs().then(() => {
            this.fields = this.buildFieldsArray(this.fieldDefs);
            this.buildFieldDropdownOptions();
        });
    },
    mounted(){
        this.resizeTableDiv();
        this.checkSelectedRows();

        // get any checkboxes from the Store if there are any:
        this.selectedRows = this.vdx_checkboxes;
    },
    destroyed(){
        window.removeEventListener("resize", this.resizeTableDiv);
    }
};
</script>
<style>
    h1,
    h2,
    a,
    p {
        color: black !important;
        text-shadow: none;
    }
    p {
        font-size: smaller;
    }

    .table td, .table th {
        padding: 6px;
    }

  .flex-wrapper {
    display: flex;
    flex-flow: column;
    height: 100vh;
  }

  .flex-wrapper .flex-row.height-by-content {
    flex: 0 0 auto;
    /* The above is shorthand for:
    flex-grow: 0,
    flex-shrink: 1,
    flex-basis: auto
    */
  }

  .flex-wrapper .flex-row.content {
    flex: 1 1 auto;
  }

  .flex-wrapper .flex-row.fixed-height {
    flex: 0 1 40px;
  }
</style>
